// Module
var code = "You should return to the cafe/bar you chose in the last episode. How do you feel about this place? Is anyone there you recognise? ";
// Exports
module.exports = code;